module.exports = "pegasus/assets/theme5/small/2.jpg";